import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
  Label,
  toast,
} from "@mindstonehq/ui";
import React, { useState } from "react";
import { Form, useRevalidator } from "react-router";
import { useMutation } from "@apollo/client/react";
import { PencilSquareIcon } from "@heroicons/react/24/solid";
import { LoadingIcon } from "~/components/icons";
import { RENAME_RESOURCE_MUTATION } from "../annotate-mutations";
import { Trans, useLingui } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";

export function DialogRenameArticle(
  props: React.PropsWithChildren<{
    title?: string;
    articleID: string;
    onOpenChange: (open: Boolean) => any;
  }>,
) {
  const { t } = useLingui();
  const [open, setOpen] = useState(false);
  const { revalidate } = useRevalidator();
  const [renameResource, { loading, error }] = useMutation(
    RENAME_RESOURCE_MUTATION,
  );
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        setOpen(o);
        props.onOpenChange(o);
      }}
    >
      <DialogTrigger asChild>{props.children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center flex-row space-x-2">
            <PencilSquareIcon className="h-6 w-6" aria-hidden="true" />
            <span><Trans>Rename this resource</Trans></span>
          </DialogTitle>
        </DialogHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            const formData = new FormData(e.currentTarget);
            return renameResource({
              variables: {
                articleId: props.articleID,
                name: (formData.get("title") as string) || "",
              },
            })
              .then(() => {
                toast.success(t(msg`Resource renamed`));
                props.onOpenChange(false);
                setOpen(false);
                revalidate();
              })
              .catch(() => {
                toast.error(t(msg`We couldn't update this resource.`));
              });
          }}
        >
          <div className={"my-4 flex flex-col space-y-4 w-full"}>
            <div className="grid w-full items-center gap-2">
              <Label htmlFor="title"><Trans>Title</Trans></Label>
              <Input
                required
                defaultValue={props.title}
                type="text"
                id="title"
                placeholder={t(msg`Name`)}
                name="title"
              />
            </div>
          </div>
          <DialogFooter className="gap-2">
            <DialogClose asChild>
              <Button variant="outline" type="button">
                <Trans>Cancel</Trans>
              </Button>
            </DialogClose>
            <Button variant="default" type="submit" disabled={loading}>
              {loading && <LoadingIcon className={"h-5 w-4 animate-spin"} />}
              <Trans>Rename</Trans>
            </Button>
          </DialogFooter>
        </Form>
      </DialogContent>
    </Dialog>
  );
}
